<main class="dossier" [class.dossier--wide]="wide()">
  <img class="paperclip" src="/assets/paperclip.svg" alt="" />
  @if (decor()) {
    <p class="stamp stamp--round decor decor--authorized" aria-hidden="true">Accès<br />autorisé</p>
    <img class="decor decor--globe" src="/assets/globe-stamp.svg" alt="" />
  }

  <header class="dossier__header">
    <p class="dossier__eyebrow">{{ eyebrow() }}</p>
    <div class="dossier__seal">
      <p class="stamp">{{ stamp() }}</p>
      @if (reference(); as reference) {
        <p class="dossier__ref">{{ reference }}</p>
      }
    </div>
  </header>

  <ng-content />
</main>
